import React from "react";
import headSectionImage from "./@Images/headSectionImage.svg";
import regulatorEscalatorImage from "./@Images/regulatorEscalatorImage.svg";
import {HeadSectionComponent} from "../../Parts/Sections";
import "./index.scss";
import SectionContainerComponent from "@Components/Sections/SectionContainer";
import SecurityPagePillarsSection from "@Pages/Security/PillarsSection";
import {
    CardComponent,
    ExplanationCardComponent,
    CardMainTitleComponent,
    CardSubTitleDComponent, IconCardComponent,
} from "@Components/Elements";
import {Col, Row} from "react-bootstrap";
import iconCheckBox from "@Icons/SVG/icon-check_box.svg";
import iconLock from "@Icons/SVG/icon-lock-xl-white.svg";
import {ReactSVG} from "react-svg";
import BadgeCardComponent from "@Components/Elements/Cards/BadgeType";

import lockIcon from "@Icons/SVG/icon-lock-xl-white.svg";
import securityIcon from "@Icons/SVG/icon-security-xl-white.svg";
import searchIcon from "@Icons/SVG/icon-search-xl-white.svg";
import thumbUpIcon from "@Icons/SVG/icon-thumb_up-xl-white.svg";
import visibilityOffIcon from "@Icons/SVG/icon-visibility_off-xl-white.svg";


import iconTransport from "@Icons/SVG/icon-transport-s-green.svg";
import iconPlane from "@Icons/SVG/icon-plane-s-green.svg";
import iconTradeCommision from "@Icons/SVG/icon-trade-commission-s-green.svg";
import iconWorld from "@Icons/SVG/icon-world_language-s-green.svg";

import iconMessage from "@Icons/SVG/icon-message-m-green.svg";
import iconVisibility from "@Icons/SVG/icon-visibility-m-green.svg";
import iconCheck from "@Icons/SVG/icon-check-m-green.svg";
import iconClaims from "@Icons/SVG/icon-claims-m-green.svg";
import {PageContainerComponent} from "@Components/Sections";



export const SecurityPage:React.FC = () => {

    return (
        <PageContainerComponent pageType={'security-page'}>

            <HeadSectionComponent
                pageName={'security-page'}
                sectionHeaderText={'Bank-Level Security Developer-Grade Transparency'}
                sectionSubText={'Your data is protected with enterprise-grade security measures and complete transparency in how we handle your information.'}
                sectionImage={headSectionImage}
            />

            <SecurityPagePillarsSection />

            <SectionContainerComponent
                id={'security-page__escalator-assistant-section'}
                sectionHeaderText={'Regulator Escalation Assistant'}
                sectionDescriptionText={'AI-powered regulatory compliance for your protection'}
            >

                <CardComponent type={1} xs={12} xl={10} className={'escalator-assistant-card-element'}>

                    <Col xs={12} xl={8} className={'escalator-assistant-card-element__data'}>
                        <Row className={'escalator-assistant-card-element__data__content'}>
                            <CardMainTitleComponent
                                title={'Automatic Regulatory Filing'} size={'lg'}
                            />
                            <CardSubTitleDComponent
                                title={'If an airline or vendor misses its legal refund deadline, C.A.R.E. files the required complaint with the appropriate authority on your behalf.'}
                            />
                            <Col xs={12} className={'escalator-assistant-card-element__data__content'}>
                                <ul className={'card-content-list card-component__content-list card-component__content-list--default'}>
                                    <li className={'card-content-list__element card-component__content-list__element'}>
                                        <span className={'card-content-list__element__icon card-component__content-list__element__icon'}>
                                            <ReactSVG src={iconTransport} wrapper={'span'} className={'card-content-list__element__icon__svg'} />
                                        </span>
                                        <span className={'card-content-list__element__text card-component__content-list__element__text'}>DOT (Department of Transportation)</span>
                                    </li>
                                    <li className={'card-content-list__element card-component__content-list__element'}>
                                        <span className={'card-content-list__element__icon card-component__content-list__element__icon'}>
                                            <ReactSVG src={iconPlane} wrapper={'span'} className={'card-content-list__element__icon__svg'} />
                                        </span>
                                        <span className={'card-content-list__element__text card-component__content-list__element__text'}>CAA (Civil Aviation Authority)</span>
                                    </li>
                                    <li className={'card-content-list__element card-component__content-list__element'}>
                                        <span className={'card-content-list__element__icon card-component__content-list__element__icon'}>
                                            <ReactSVG src={iconTradeCommision} wrapper={'span'} className={'card-content-list__element__icon__svg'} />
                                        </span>
                                        <span className={'card-content-list__element__text card-component__content-list__element__text'}>FTC (Federal Trade Commission)</span>
                                    </li>
                                    <li className={'card-content-list__element card-component__content-list__element'}>
                                        <span className={'card-content-list__element__icon card-component__content-list__element__icon'}>
                                            <ReactSVG src={iconWorld} wrapper={'span'} className={'card-content-list__element__icon__svg'} />
                                        </span>
                                        <span className={'card-content-list__element__text card-component__content-list__element__text'}>Equivalent international authorities</span>
                                    </li>
                                </ul>
                            </Col>
                        </Row>
                    </Col>

                    <Col xs={12} xl={4} className={'escalator-assistant-card-element__image'}>
                        <Row className={'escalator-assistant-card-element__image__content'}>
                            <img src={regulatorEscalatorImage} alt={''} />
                        </Row>
                    </Col>

                </CardComponent>

            </SectionContainerComponent>

            <SectionContainerComponent
                id={'security-page__how-it-works-section'}
                sectionHeaderText={'How the Send As Option Works'}
                sectionDescriptionText={'Edge-cases only - Complete transparency and control'}
            >

                <Col xs={12} xl={6} className={'security-page__how-it-works-section__information'}>
                    <Row className={'security-page__how-it-works-section__information__content'}>
                        <ExplanationCardComponent
                            cardDecoration={{ cardDecorationType: 'orderNr', cardDecorationValue: '1' }}
                            cardMainTitle={'Opt-in Toggle During Onboarding'}
                            cardDescription={'You choose whether to enable the Send As feature during initial setup. It\'s completely optional.'}
                        />
                        <ExplanationCardComponent
                            cardDecoration={{ cardDecorationType: 'orderNr', cardDecorationValue: '2' }}
                            cardMainTitle={'C.A.R.E. Drafts the Claim Email'}
                            cardDescription={'Our AI creates the claim message, then sends it via limited "Send As" scope only for mandated claims.'}
                        />
                        <ExplanationCardComponent
                            cardDecoration={{ cardDecorationType: 'orderNr', cardDecorationValue: '3' }}
                            cardMainTitle={'Copy Lands in Your Sent Folder'}
                            cardDescription={'Every sent message appears in your Sent folder for full transparency. You see exactly what was sent.'}
                        />
                        <ExplanationCardComponent
                            cardDecoration={{ cardDecorationType: 'orderNr', cardDecorationValue: '4' }}
                            cardMainTitle={'Revoke Permission Anytime'}
                            cardDescription={'Revoke the permission at any time - Qyvo instantly reverts to read- only mode.'}
                        />
                    </Row>
                </Col>

                <Col xs={12} xl={6} className={'security-page__how-it-works-section__guarantees'}>
                    <Row className={'security-page__how-it-works-section__guarantees__content'}>

                        <Col xs={12} className={'security-page__how-it-works-section__guarantees__elements-list'}>
                            <Row className={'security-page__how-it-works-section__guarantees__elements-list__content'}>

                                <Col xs={12} className={'security-page__how-it-works-section__guarantees__elements-list__header'}>
                                    <span>Our Guarantees</span>
                                </Col>

                                <Col xs={12} className={'security-page__how-it-works-section__guarantees__elements-list__element'}>
                                    <Row className={'security-page__how-it-works-section__guarantees__elements-list__element__content'}>
                                        <Col xs={2} xl={1} className={'security-page__how-it-works-section__guarantees__elements-list__element__icon'}>
                                            <ReactSVG src={iconMessage} wrapper={'span'} />
                                        </Col>
                                        <Col xs={10} xl={11} className={'security-page__how-it-works-section__guarantees__elements-list__element__data'}>
                                            <span className={'security-page__how-it-works-section__guarantees__elements-list__element__data__title'}>No Marketing Emails</span>
                                            <span className={'security-page__how-it-works-section__guarantees__elements-list__element__data__description'}>This token is used solely for mandated claim messages, never for marketing.</span>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={12} className={'security-page__how-it-works-section__guarantees__elements-list__element'}>
                                    <Row className={'security-page__how-it-works-section__guarantees__elements-list__element__content'}>
                                        <Col xs={2} xl={1} className={'security-page__how-it-works-section__guarantees__elements-list__element__icon'}>
                                            <ReactSVG src={iconVisibility} wrapper={'span'} />
                                        </Col>
                                        <Col xs={10} xl={11} className={'security-page__how-it-works-section__guarantees__elements-list__element__data'}>
                                            <span className={'security-page__how-it-works-section__guarantees__elements-list__element__data__title'}>Complete Transparency</span>
                                            <span className={'security-page__how-it-works-section__guarantees__elements-list__element__data__description'}>Every action is logged and visible in your email account.</span>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={12} className={'security-page__how-it-works-section__guarantees__elements-list__element'}>
                                    <Row className={'security-page__how-it-works-section__guarantees__elements-list__element__content'}>
                                        <Col xs={2} xl={1} className={'security-page__how-it-works-section__guarantees__elements-list__element__icon'}>
                                            <ReactSVG src={iconCheck} wrapper={'span'} />
                                        </Col>
                                        <Col xs={10} xl={11} className={'security-page__how-it-works-section__guarantees__elements-list__element__data'}>
                                            <span className={'security-page__how-it-works-section__guarantees__elements-list__element__data__title'}>Instant Revocation</span>
                                            <span className={'security-page__how-it-works-section__guarantees__elements-list__element__data__description'}>Disable sending permissions with one click at any time.</span>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={12} className={'security-page__how-it-works-section__guarantees__elements-list__element'}>
                                    <Row className={'security-page__how-it-works-section__guarantees__elements-list__element__content'}>
                                        <Col xs={2} xl={1} className={'security-page__how-it-works-section__guarantees__elements-list__element__icon'}>
                                            <ReactSVG src={iconClaims} wrapper={'span'} />
                                        </Col>
                                        <Col xs={10} xl={11} className={'security-page__how-it-works-section__guarantees__elements-list__element__data'}>
                                            <span className={'security-page__how-it-works-section__guarantees__elements-list__element__data__title'}>Claims Only</span>
                                            <span className={'security-page__how-it-works-section__guarantees__elements-list__element__data__description'}>Limited scope exclusively for legitimate refund claims.</span>
                                        </Col>
                                    </Row>
                                </Col>

                            </Row>
                        </Col>

                    </Row>
                </Col>

            </SectionContainerComponent>

            <SectionContainerComponent id={'security-page__information-section'}>

                <IconCardComponent
                    cardIcon={{ iconSrc: lockIcon, iconSize: 'xl', iconBackground: 'default' }}
                    cardTitle={`TLS 1.3`}
                    cardDescription={`<span>Encrypted</span>`}
                    xs={6} xl={2}
                />

                <IconCardComponent
                    cardIcon={{ iconSrc: securityIcon, iconSize: 'xl', iconBackground: 'default' }}
                    cardTitle={`AES-256`}
                    cardDescription={`<span>Protected</span>`}
                    xs={6} xl={2}
                />

                <IconCardComponent
                    cardIcon={{ iconSrc: searchIcon, iconSize: 'xl', iconBackground: 'default' }}
                    cardTitle={`GDPR`}
                    cardDescription={`<span>Compliant</span>`}
                    xs={6} xl={2}
                />

                <IconCardComponent
                    cardIcon={{ iconSrc: thumbUpIcon, iconSize: 'xl', iconBackground: 'default' }}
                    cardTitle={`SOC-2 Type I Underway`}
                    cardDescription={`<span>Audit Pending</span>`}
                    xs={6} xl={2}
                />

                <IconCardComponent
                    cardIcon={{ iconSrc: visibilityOffIcon, iconSize: 'xl', iconBackground: 'default' }}
                    cardTitle={`Read-Only`}
                    cardDescription={`<span>Default</span>`}
                    xs={6} xl={2}
                />

            </SectionContainerComponent>

        </PageContainerComponent>
    );

};


export default SecurityPage;
